/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Portal API Gateway
 * OpenAPI spec version: 2.0.0
 */

/**
 * Type of prize / reward in a prize draw.
 */
export type PrizeType = (typeof PrizeType)[keyof typeof PrizeType]

export const PrizeType = {
  YEAR_OF_ENERGY: "YEAR_OF_ENERGY",
  ACCOUNT_CREDIT_10_POUNDS: "ACCOUNT_CREDIT_10_POUNDS",
  ACCOUNT_CREDIT_20_POUNDS: "ACCOUNT_CREDIT_20_POUNDS",
  ACCOUNT_CREDIT: "ACCOUNT_CREDIT",
  YEAR_OF_ENERGY_LEGACY: "YEAR_OF_ENERGY_LEGACY",
  EV_CHARGER: "EV_CHARGER",
  EV_CHARGER_CREDIT: "EV_CHARGER_CREDIT",
  HOMETREE: "HOMETREE",
  VOUCHER: "VOUCHER",
} as const
